import { Component, Input } from '@angular/core';
import { ISubHeader } from '../../classes/interfaces/subheader.interface';

@Component({
    selector: 'app-subheader',
    templateUrl: './subheader.component.html',
    styleUrl: './subheader.component.scss',
    standalone: false
})
export class SubheaderComponent {

  @Input() header: ISubHeader = {
    main: '',
    sub: ''
  };
  
  @Input() isSubSection: boolean = false;
}
